module.exports = __webpack_public_path__ + "img/15100F_241D1B_292424_2C2C27-256px.860c521e.png";